import { Crown } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface StudioNameProps {
  studioName: string | null | undefined;
  displayName: string;
  isPremium?: boolean;
  premiumEndDate?: string | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function StudioName({
  studioName,
  displayName,
  isPremium = false,
  premiumEndDate,
  className = "",
  size = 'md'
}: StudioNameProps) {
  const name = studioName || displayName;

  // Check if premium is active
  const isPremiumActive = isPremium && (
    !premiumEndDate || new Date(premiumEndDate) > new Date()
  );

  // Crown size based on size prop
  const crownSize = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  }[size];

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      {name}
      {isPremiumActive && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Crown className={`${crownSize} text-primary`} />
            </TooltipTrigger>
            <TooltipContent>
              <p>Premium Studio</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </span>
  );
}

